import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="video"
export default class extends Controller {
  connect() {
    const video = this.element;
    video.play().catch(() => {});
  }
}
